import React from 'react';

const MyWishList = () => {
    return (
        <div>
            this page is for buyers Wishlist
        </div>
    );
};

export default MyWishList;